"use client";

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface FormActionsProps {
  canSubmit: boolean;
  isPristine: boolean;
  isSubmitting: boolean;
  /** False mutes the submit button but leaves it pressable, so pressing it can reveal what is missing. */
  isComplete?: boolean;
  label: string;
  pendingLabel?: string;
  onCancel?: () => void;
  cancelVariant?: "outline" | "ghost";
  disabled?: boolean;
  size?: "sm" | "default";
}

export function FormActions({
  canSubmit,
  isPristine,
  isSubmitting,
  isComplete = true,
  label,
  pendingLabel,
  onCancel,
  cancelVariant = "outline",
  disabled,
  size,
}: FormActionsProps) {
  return (
    <div className="flex justify-end gap-2">
      {onCancel && (
        <Button type="button" variant={cancelVariant} size={size} onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      )}
      <Button
        type="submit"
        size={size}
        disabled={!canSubmit || isPristine || isSubmitting || disabled}
        className={cn(!isComplete && "opacity-50")}
      >
        {isSubmitting ? (pendingLabel ?? "Saving...") : label}
      </Button>
    </div>
  );
}
